/**
 * Shared customer-dark gate for Vanturis Passport.
 *
 * Rendered for any authenticated protected route while PASSPORT_ENABLED=false
 * (the backend answers 404 for every customer route). Presents one polished
 * "Passport is coming soon" experience instead of live-looking empty pages —
 * no feature existence or data is leaked.
 */
import { Link } from "react-router-dom";
import { ShieldCheck, KeyRound, Share2, Building2 } from "lucide-react";
import { pp, marketplaceHome } from "@/passport/product";

export default function PassportComingSoon() {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12 md:py-16" data-testid="passport-coming-soon">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#C6A15B]">Dashboard</div>
      <h1 className="mt-2 text-3xl font-semibold text-white">Your Passport</h1>
      <div className="mt-8 p-8 border border-neutral-800 bg-neutral-900/40">
        <ShieldCheck className="w-6 h-6 text-[#C6A15B] mb-4" strokeWidth={1.5} />
        <div className="text-lg font-semibold text-white">Passport is coming soon</div>
        <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
          Passport features aren't available on your account yet. Your Vanturis account will be
          ready the moment they open.
        </p>
        <ul className="mt-5 space-y-3 text-sm text-neutral-300">
          <li className="flex gap-3"><KeyRound className="w-4 h-4 text-[#C6A15B] mt-0.5 shrink-0" />
            Claim a vehicle you own to start its permanent record.</li>
          <li className="flex gap-3"><Share2 className="w-4 h-4 text-[#C6A15B] mt-0.5 shrink-0" />
            Received a share invitation? Redeem it to view a Passport shared with you.</li>
          <li className="flex gap-3"><Building2 className="w-4 h-4 text-[#C6A15B] mt-0.5 shrink-0" />
            Service providers contribute authorized records through their organization.</li>
        </ul>
        <div className="mt-7 flex flex-wrap gap-3">
          <Link to={pp("/")}
                className="px-5 py-3 border border-neutral-700 text-neutral-300 text-[11px] uppercase tracking-[0.2em] hover:border-[#C6A15B] hover:text-[#C6A15B] transition-colors"
                data-testid="passport-coming-soon-learn">Learn about Passport</Link>
          <Link to={marketplaceHome()}
                className="px-5 py-3 text-[11px] uppercase tracking-[0.2em] text-neutral-500 hover:text-[#C6A15B] transition-colors"
                data-testid="passport-coming-soon-marketplace">Return to Marketplace</Link>
        </div>
      </div>
    </div>
  );
}
